export const DashboardHeader = {
    headline: 'Dashboard HRIS',
};
export const VisitHeader = {
    headline: 'Absen Visit',
};